/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import Page from '../../../Component/Pagination/Pagination'
import HeaderTable from '../../../Component/BaseComponent/HeaderTable'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import $ from 'jquery'
import TMS from '../../BaseComponent/TMS'

class ReportTaskUnit extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      printInfo: [],
      editModal: false,
      deleteModal: false,
      sec: [],
      tasks: [],
      department: []
    }
  }

  getAll = (
    params = sessionStorage.getItem('params'),
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal')
  ) => {
    http
      .get(
        `${TMS.TMS_MANAGE_BASE_TASKUNIT_REPORT}?export=false&pageNumber=${pageNumber}&pageSize=${pageSize}&${params}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          this.setState({
            list: response.data.object.result,
            countAll: response.data.object.countAll
          })
          $('.showBaseTable').fadeIn()
        } else {
          this.setState({
            list: [],
            countAll: ''
          })
          $('.showBaseTable').fadeOut()
        }
      })
  }

  changeSec(e) {}

  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
    // http.get(`${TMS.TMS_MANAGE_BASE_SECTION_LIST}`,{
    //
    // }).then(response=>{
    //     if(response.data.error === null){
    //         this.setState({
    //             sec : response.data.object
    //         })
    //     }
    // })

    this.getAll()

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
  }

  activate = (enabled, id) => {
    if (enabled) {
      let data = {
        id: id
      }

      http
        .post(`${TMS.TMS_MANAGE_BASE_TASKUNIT_DISABLE}`, data, {})
        .then((response) => {
          if (response.data.error === null) {
            this.getAll()
          } else {
            // message.error(response.data.description)
          }
        })
        .catch((error) => {
          // alert(JSON.stringify(error))
        })
    } else {
      let data = {
        id: id
      }

      http
        .post(`${TMS.TMS_MANAGE_BASE_TASKUNIT_ENABLE}`, data, {})
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error === null) {
            this.getAll()
          } else {
            // message.error(response.data.description)
          }
        })
        .catch((error) => {
          // alert(JSON.stringify(error))
        })
    }
  }

  edit = (id, title, description) => {
    this.setState({
      id,
      title,
      description,
      editModal: !this.state.editModal
    })
  }

  editToggle = () => {
    this.setState({
      id: '',
      title: '',
      sectionId: '',
      timeMinuteMin: '',
      timeMinuteMax: '',
      needProvider: '',
      needProduct: '',
      editModal: !this.state.editModal,
      orgId: ''
    })
  }
  editCancel = () => {
    this.editToggle()
  }

  editOk = () => {
    let title = document.getElementById('titleM').value
    let description = document.getElementById('description').value
    let {id} = this.state
    let formError = false
    if (title === '') {
      formError = true
      message.error('عنوان وارد شود')
    }

    if (!formError) {
      let data = {
        id,
        title,
        description
      }
      http.post(`${TMS.TMS_MANAGE_BASE_TASKUNIT_UPDATE}`, data, {}).then((response) => {
        if (response.data.error === null) {
          message.success('واحد فعالیت ویرایش شد')
          this.getAll()
          this.editToggle()
        } else {
          // message.error(response.data.description)
        }
      })
    }
  }

  delete = (id, title) => {
    this.setState({
      id,
      title,
      deleteModal: !this.state.deleteModal
    })
  }
  toggleCancelDelete = () => {
    this.setState({
      id: '',
      title: '',
      deleteModal: !this.state.deleteModal
    })
  }
  deleteCancel = () => {
    this.toggleCancelDelete()
  }
  deleteOk = () => {
    let {id} = this.state
    let data = {
      id
    }
    http.post(`${TMS.TMS_MANAGE_BASE_TASKUNIT_DELETE}`, data, {}).then((response) => {
      if (response.data.error === null) {
        message.success('نوع فعالیت با موفقیت حذف شد')
        this.getAll()
        this.toggleCancelDelete()
      } else {
        this.setState({
          deleteModal: false
        })
      }
    })
  }

  changeDropDown(data) {
    this.setState({
      list: data,
      lengthProducts: this.state.countAll
    })
  }

  onResultFetched(data) {
    this.setState({
      list: data
    })
  }

  changeField(e) {
    let target = e.target
    let value = target.value
    let name = target.name
    this.setState({
      [name]: value
    })
  }

  exportExcel = () => {
    http
      .get(
        `${TMS.TMS_MANAGE_BASE_TASKUNIT_REPORT}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['enabled']) {
              excelReport[i]['enabled'] = 'فعال'
            } else {
              excelReport[i]['enabled'] = 'غیر فعال'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${TMS.TMS_MANAGE_BASE_TASKUNIT_REPORT}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  filter() {
    let title = document.getElementById('title').value.trim()
    sessionStorage.setItem('params', `title=${title}`)
    this.getAll()
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let printCol = ['ردیف', 'عنوان', 'توضیحات']
    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="اطلاعات پایه واحد فعالیت"
              headerColSpan={3}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={1}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((temp, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{temp.title}</td>
                  <td>{temp.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="اطلاعات پایه واحد فعالیت.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'title'}
                field={'title'}
                title={'عنوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'description'}
                field={'description'}
                title={'توضیحات'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>مدیریت فعالیت ها</li>
            <li>واحد های فعالیت</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/base/create/tms/taskUnit"
                  url={TMS.TMS_MANAGE_BASE_TASKUNIT_REPORT}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printComponent={this.printTable}
                  execelUrl={TMS.TMS_MANAGE_BASE_TASKUNIT_REPORT + '?export=true'}
                  excelColumns={[]}
                  titleAdd="افزودن نوع فعالیت"
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    عنوان
                  </label>
                  <input type="text" id="title" className="form-control" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>عنوان</td>
                    <td>توضیحات</td>
                    <td>فعال</td>
                    <td>ویرایش</td>
                    <td>حذف</td>
                  </tr>
                  {this.state.list.map((temp, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{temp.title}</td>
                      <td>{temp.description}</td>
                      <td>
                        <button onClick={() => this.activate(temp.enabled, temp.id)}>
                          {temp.enabled ? (
                            <img src={require('../../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.edit(temp.id, temp.title, temp.description)}>
                          <img src={require('../../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.delete(temp.id, temp.title)}>
                          <img src={require('../../../image/trash.svg')} alt={'trash'} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.countAll}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={TMS.TMS_MANAGE_BASE_TASKUNIT_REPORT}
                />
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={this.state.deleteModal} toggle={this.toggleCancelDelete} size="sm">
          <ModalHeader toggle={this.toggleCancelDelete}>حذف فعالیت</ModalHeader>
          <ModalBody>
            <p className="titleSm">آیا از حذف واحد فعالیت {this.state.title} مطمئن هستید؟؟؟</p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteOk}>
              حذف
            </button>
            <button className="cancelBtnModal" onClick={this.deleteCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.editModal} toggle={this.editToggle} size="sm">
          <ModalHeader toggle={this.editToggle}>ویرایش فعالیت</ModalHeader>
          <ModalBody>
            <div className="modalForm">
              <div className="formComponent">
                <label>
                  {' '}
                  عنوان : <span className="requireFiled">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="title"
                  onChange={this.changeField.bind(this)}
                  defaultValue={this.state.title}
                  id="titleM"
                />
              </div>

              <div className="formComponent">
                <label> توضیحات :</label>
                <textarea
                  className="form-control"
                  defaultValue={this.state.description}
                  onChange={this.changeField.bind(this)}
                  id="description"
                />

                {/*<input className='form-control' type='text' name='description' onChange={this.changeField.bind(this)}*/}
                {/*       defaultValue={this.state.description} id='description'/>*/}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.editOk}>
              ویرایش{' '}
            </button>
            <button className="cancelBtnModal" onClick={this.editCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default ReportTaskUnit
